import React, { FC } from 'react';
import { SignedNumber } from '@tradingblock/components';
import { useSharedPLCalculations } from '../../../hooks/useSharedPLCalculations';
import _ from 'lodash';

export const PositionLegDailyPL: FC<{ positionIds: string[] }> = ({ positionIds }) => {
  const { aggregatePositionPerformances } = useSharedPLCalculations();
  const pnl = aggregatePositionPerformances(positionIds);
  return <>{!_.isNaN(pnl.pnl) && <SignedNumber value={pnl.pnl} bold currency hideIcon />}</>;
};
